import type { TreeMenuItem } from '@refinedev/core';
import { canAccessResource } from '@/providers/accessControlProvider';

/** The menu without the pages the user cannot open, and without groups left empty. */
export const accessibleMenuTree = (tree: Array<TreeMenuItem>): Array<TreeMenuItem> =>
  tree
    .filter(({ name }) => canAccessResource(name))
    .map((item) => ({ ...item, children: accessibleMenuTree(item.children) }))
    .filter((item) => item.route !== undefined || item.children.length > 0);

/** The sidebar menu: a group with one page left shows that page as a plain row. */
export const visibleMenuTree = (tree: Array<TreeMenuItem>): Array<TreeMenuItem> =>
  accessibleMenuTree(tree).map((item) => {
    const [onlyChild] = item.children;
    return item.route === undefined && item.children.length === 1 && onlyChild ? onlyChild : item;
  });
